import { activeProfileInitialState } from './initial-state';
import { ActiveProfileActions } from './action-creators';
import ActiveProfileState from './state';
import * as actions from './actions';

const activeProfileReducer = (
  state: ActiveProfileState = activeProfileInitialState,
  action: ActiveProfileActions
): ActiveProfileState => {
  switch (action.type) {
    case actions.SET_ACTIVE_PROFILE: {
      return {
        ...state,
        isArtist: action.isArtist,
        id: action.id,
      };
    }

    default:
      return state;
  }
};

export default activeProfileReducer;
